import React from "react";
import "./Apply_Btn.css";
import { Button } from "react-bootstrap";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Apply_Btn({ btnText }) {
    return (
        <button className="Apply_Btn_holder">
            <p className='btn_text'>{btnText}</p>
            <div className='icon_holder'>
                <FontAwesomeIcon icon={faArrowRight} className='arrow_icon' />
            </div>
        </button>
    );
}

export default Apply_Btn;
